import { useEffect, useState } from "react";
import { BsChevronDown, BsQuestionSquare } from "react-icons/bs";

import { SelectWrapper } from "../selectInput/style";
import CustomTooltip from "../Tooltip";

export interface ISelectProps {
  options: any[];
  placeholder: string;
  prompt: string;
  fullWidth: boolean;
  name: string;
  indexLevel: number;
  shortWidth?: boolean;
  tooltip?: string;
  updateValidity: (name: string, validity: boolean) => void;
  updateData: (
    name: string,
    value: { id: string | number; title: string }
  ) => void;
  initialValue?: string;
  required?: boolean;
}

export function SelectParent({
  options,
  placeholder,
  prompt,
  fullWidth,
  updateValidity,
  updateData,
  name,
  indexLevel,
  tooltip,
  initialValue,
  required,
}: ISelectProps) {
  const [selectedValue, setSelectedValue] = useState("");
  const [showOptions, setShowOptions] = useState(false);
  const [clicked, setClicked] = useState(false);

  useEffect(() => {
    if (initialValue) {
      updateValidity(name, true);
      setSelectedValue(initialValue);
      updateData(name, initialValue as any);
    }

    // eslint-disable-next-line
  }, [initialValue]);

  function onSelectClicked() {
    setShowOptions(!showOptions);
    setClicked(true);
  }
  const onSelectOption = (item: any) => {
    setSelectedValue(item);
    setShowOptions(false);
    updateValidity(name, true);
    updateData(name, item);
  };

  return (
    <SelectWrapper
      indexLevel={indexLevel}
      showOptions={showOptions}
      fullWidth={fullWidth}
    >
      <div className="label-wrapper">
        <label>
          {prompt} {required ? <span style={{ color: "red" }}>*</span> : null}
        </label>

        {tooltip ? (
          <CustomTooltip title={tooltip}>
            <div>
              <BsQuestionSquare className="tooltip-icon" />
            </div>
          </CustomTooltip>
        ) : null}
      </div>
      <div className="select-wrapper">
        <div onClick={onSelectClicked} className="select-input">
          {selectedValue ? <h3>{selectedValue}</h3> : <h4>{placeholder}</h4>}
          <BsChevronDown className="icon" />
        </div>
        {clicked && !showOptions && !selectedValue && (
          <h3 className="error-message">Please select an option</h3>
        )}
        {showOptions && (
          <ul className="select-options">
            {options &&
              options.map((item) => {
                return (
                  <li
                    onClick={() => onSelectOption(item.state.name)}
                    key={item.state.name}
                    value={item.state.name}
                  >
                    {item.state.name}
                  </li>
                );
              })}
          </ul>
        )}
      </div>
    </SelectWrapper>
  );
}
